import { SText } from '@setvi/shared/components';
import { OrderItemHistory } from '@setvi/shared/services/react-query/query/orders/types';
import moment from 'moment';
import {
  Cost,
  Price,
  Profit
} from 'pages/products/components/products-list/useProductColumns/contents';

export const orderHistoryColumns = [
  {
    id: 'orderedOn',
    label: 'Ordered On',
    width: '20%',
    cellContent: ({ createdDate }: OrderItemHistory) => (
      <SText title={moment.utc(createdDate).format('MM/DD/YYYY')} />
    )
  },
  {
    id: 'orderedQty',
    label: 'Ordered Qty',
    width: '20%',
    cellContent: ({ quantity }: OrderItemHistory) => (
      <SText title={quantity.toString()} />
    )
  },
  {
    id: 'sell',
    label: 'Sell',
    width: '20%',
    cellContent: ({ sell }: OrderItemHistory) => <Price value={sell} />
  },
  {
    id: 'cost',
    label: 'Cost',
    width: '20%',
    cellContent: ({ cost }: OrderItemHistory) => <Cost value={cost} />
  },
  {
    id: 'profit',
    label: 'Profit Margin',
    width: '20%',
    cellContent: ({ sell, cost }: OrderItemHistory) => (
      <Profit price={sell} cost={cost} />
    )
  }
];
